// react
import React from "react"
import { connect } from "react-redux"
// app
import Details from "components/person/Details"
import Notes from "components/person/Notes"

import { getNotes, postNote } from "actions/profile/notes/actions.js"
import { getPerson, putPerson } from "actions/profile/person/actions.js"


class Step1 extends React.Component {
    constructor(props) {
        super()

        this.onPersonSave = person => this.props.putPerson(person)

        this.onNoteAdd = note => {
            note.personid = props.personid
            note.userid = props.userid
            this.props.postNote(note)
        }
    }

    componentDidMount() {
        const personid = this.props.personid
        
        this.props.getPerson(personid)

        if (this.props.isAdmin === true) {
            this.props.getNotes(personid)
        }
    }

    render() {
        return (
            <div>
                <Details
                    person={ this.props.person }
                    onSave={ this.onPersonSave }
                />
                { this.props.isAdmin === true ?
                    <Notes
                        data={ this.props.notes }
                        onAdd={ this.onNoteAdd }
                    />
                    : null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        person: state.profile.person.get("data"),
        notes: state.profile.notes.get("data"),
        userid: state.user.get("id"),
        isAdmin: (state.user.get("admin") === 1)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPerson: id => dispatch(getPerson(id)),
        putPerson: person => dispatch(putPerson(person)),

        getNotes: personid => dispatch(getNotes(personid)),
        postNote: note => dispatch(postNote(note))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step1)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step1.js
 **/